import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import PhoneGate from '@/pages/PhoneGate'

const ProtectedRoute: React.FC = () => {
  const { athlete: currentUser, isLoading: loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return <div></div>
  }
  if (!currentUser || !currentUser.id) {
    return <Navigate to="/signin" replace />
  }

  // Production requires a verified phone before anything else, including the welcome walkthrough
  if (currentUser.phone_verification_required) {
    return <PhoneGate />
  }

  // Redirect authenticated users away from sign-in page
  if (location.pathname === '/signin') {
    return <Navigate to="/" replace />
  }

  // Send new users through the welcome walkthrough
  if (!currentUser.welcome_completed && location.pathname !== '/welcome') {
    return <Navigate to="/welcome" replace />
  }

  // Redirect users who already completed welcome away from /welcome
  if (currentUser.welcome_completed && location.pathname === '/welcome') {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}

export default ProtectedRoute
